import { render } from "./ChoiseCompany.vue?vue&type=template&id=60f4e741&scoped=true"
import script from "./ChoiseCompany.vue?vue&type=script&lang=js"
export * from "./ChoiseCompany.vue?vue&type=script&lang=js"

import "./ChoiseCompany.vue?vue&type=style&index=0&id=60f4e741&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f4e741"]])

export default __exports__